import { render, staticRenderFns } from "./SubProductDetails.vue?vue&type=template&id=7c8096bc&"
import script from "./SubProductDetails.vue?vue&type=script&lang=js&"
export * from "./SubProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports